<template>
  <section
      id="generic_hero"
      class="generic-hero push-v--desktop--small push-v--tablet--small push-v--mobile--small"
  >
    <div class="generic-hero__content">
      <div class="left-bg bg--primary-midnight">
        <div ref="textBox" class="content__wrapper">
          <div class="content__parent">
            <div class="generic-hero__title">
              <!-- <h1 class="generic-hero__title-image"> -->
              <!-- <Collective /> -->
              <span class="visually-hidden">{{ title }}</span>
              <!-- </h1> -->

              <p class="generic-hero__slogan text-right--desktop">{{ firstHeaderTitle || slogan }}</p>
              <h1 class="generic-hero__title--main">
                {{ title }}
              </h1>
              <p class="generic-hero__subtitle">{{ bodyText }}</p>
              <!-- <p v-if="body" class="generic-hero__subtitle" v-html="body" /> -->
            </div>
          </div>
          <div class="generic-hero__buttons--wrapper">
            <a v-if="externalLink" :href="externalLink" class="generic-hero__button" @click="clickExternalCta">{{ cta360Text }}</a>
            <button v-else class="generic-hero__button" @click="clickBookCta">{{ callToActionLinkText }}</button>
            <a v-if="cta360Link && cta360Text" :href="cta360Link" class="generic-hero__button" @click="click360Link">{{ cta360Text }}</a>
          </div>
        </div>
        <div ref="arrowBoxLocation" class="left-bg--arrow-parent" @click="scrollBelow"><ArrowIcon class="left-bg--arrow-icon" /></div>
      </div>
      <div class="right-bg bg--white">
        <div id="generic-hero-image" ref="genricHeroImage" class="right-bg__image">
          <KenticoResponsiveImage :src="image.url" :alt="image.description" class="generic-hero__image" :sizes="imageSizes" @load="onImageLoad" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { forceObject } from '~/utils/processor';
import { getBookingStayPath } from '~/utils/booking';
import getStatic from '~/utils/get-static';
import { clickedCta, trackClickedCta } from '~/utils/gtm-events.js';
// import WigglyLine from '~/assets/icons/line.svg?inline';
import ArrowIcon from '~/assets/icons/new/arrow-down.svg?inline';
import { BREAKPOINTS, BREAKPOINT_XS, BREAKPOINT_MD, BREAKPOINT_LG, TABNAME_SHORT_STAY, TABNAME_LONG_STAY } from '~/utils/constants';
import { gsap, TimelineLite, CSSPlugin, Power1 as Sine } from 'gsap';


export default {
  components: {
    ArrowIcon,
  },

  props: {
    image: {
      type: Object,
      default() {
        return {
          url: getStatic('/images/content/location/hero.jpg'),
          description: 'Alt tag',
        };
      },
      required: true,
    },
    backgroundColour: {
      type: Array,
      default() {
        return [
          {
            name: 'Pale Yellow',
          },
        ];
      },
    },
    imageBackgroundShapeColor: {
      type: Array,
      default() {
        return [
          {
            name: 'Yellow',
          },
        ];
      },
    },
    label: { type: String, default: '' },
    title: { type: String, default: 'Page name', required: true },
    firstHeaderTitle: { type: String, default: '' },
    firstHeaderSubtitle: { type: String, default: '' },
    secondHeaderTitle: { type: String, default: '' },
    secondHeaderSubtitle: { type: String, default: '' },
    cta360Text: { type: String, default: '' },
    cta360Link: { type: String, default: '' },
    externalLink: { type: String, default: '' },
    useInternalCtaAsAnchorLink: {
      type: Array,
      default() {
        return [
          {
            name: 'No',
            codename: 'no',
          },
        ];
      },
    },
    slogan: { type: String, default: 'Be More Together' },
    body: {
      type: String,
      default:
        '<p></p>',
      required: true,
    },
    bodyText: { type: String, default: '' },
    callToActionLinkTextTour: { type: String, default: 'Request Tour' },
    callToActionLinkText: { type: String, default: 'Book' },

    enabled: { type: Array, default: null },
    distributorId: { type: String, default: null },
  },
  data() {
    return {
      imageSizes: {
        default: [776, 646],
        sizes: [
          { breakpoint: BREAKPOINTS[BREAKPOINT_XS], width: 776, height: 646 },
          { breakpoint: BREAKPOINTS[BREAKPOINT_MD], width: 776, height: 646 },
          { breakpoint: BREAKPOINTS[BREAKPOINT_LG], width: 776, height: 646 },
        ],
      },
    };
  },
  computed: {
    backgroundColourObj() {
      return forceObject(this.backgroundColour);
    },
    imageBackgroundShapeColorObj() {
      return forceObject(this.imageBackgroundShapeColor);
    },
    callToActionLinkSlug() {


      return null;
    },

    addSeperator() {
      if (
        (this.firstHeaderTitle && this.firstHeaderSubtitle && this.secondHeaderTitle && this.secondHeaderSubtitle) ||
        (this.firstHeaderTitle && this.secondHeaderTitle)
      ) {
        return true;
      }

      return false;
    },
  },
  mounted() {
    this.animate();
  },
  methods: {
    bookingEnabled(type) {
      if (this.enabled) {
        return this.enabled.filter(function(ele) {
          return (ele.codename == type);
        }).length > 0;
      }
      return false;
    },
    stringToClass(string) {
      return string.toLowerCase().replace(' ', '-');
    },
    colourClass(colorObj) {
      if (colorObj && colorObj.name) {
        const { name } = colorObj;
        return `bg--${this.stringToClass(name)}`;
      }

      return false;
    },
    getLocation() {
      const parent = this.$parent;
      const path = getBookingStayPath(parent.$attrs.slug);
      const location = parent.title;
      return { location, path };

    },
    scrollBelow() {
      window.scrollBy({
        top: window.innerHeight,
        left: 0,
        behavior: 'smooth',
      });
    },
    onImageLoad(event) {
      const { heroImage } = this.$refs;
      const tl = new TimelineLite();
      tl
          .fromTo(heroImage, { autoAlpha: 0.3, x: 150 }, { autoAlpha: 1, x: 0, duration: 1, ease: Sine.easeOut });
    },
    animate() {
      const { textBox, arrowBoxLocation, genricHeroImage } = this.$refs;
      gsap.registerPlugin(CSSPlugin);

      const tl = new TimelineLite();
      tl
          .fromTo(genricHeroImage, { autoAlpha: 0.3, x: 150 }, { autoAlpha: 1, x: 0, duration: 1, ease: Sine.easeOut })
          .fromTo(textBox, { autoAlpha: 0, y: 150 }, { autoAlpha: 1, y: 0, duration: 0.7, ease: Sine.easeOut }, '-=0.4')
          .fromTo(arrowBoxLocation, { y: -100, autoAlpha: 0.8 }, { y: 0, autoAlpha: 1, repeat: 4, yoyo: true, duration: 1, ease: Sine.easeIn }, '-=0.4');

    },
    click360Link() {
      const eventData = {
        category: 'LocationPage',
        action: 'Click',
        label: 'Take360Tour',
        property: null,
        value: this.getLocation(),
        event: 'clickedCta',
      };
      trackClickedCta(this.$gtm, eventData);
    },
    clickExternalCta() {
      clickedCta(this.$gtm, 'book', this.getLocation(), null, null);
    },
    clickBookCta() {
      clickedCta(this.$gtm, 'book', this.getLocation(), null, null);
      if ( this.useInternalCtaAsAnchorLink[0] && this.useInternalCtaAsAnchorLink[0].codename === 'yes') {
        const ele = document.querySelector('#co-working');
        ele && ele.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        this.openStay();
      }
    },
    openStay() {
      if (this.$parent.bookingOptions.bookingUrl) {
        window.open(this.$parent.bookingOptions.bookingUrl);
      } else {
        const { enabled=[] } = this.$parent.bookingOptions;
        const isShortStayEnabled = enabled.some((type)=>type.name.toLowerCase().indexOf('short') >= 0);

        const { location } = this.getLocation();
        this.$modal.show('booking', {
          location,
          bookingType: isShortStayEnabled ? TABNAME_SHORT_STAY : TABNAME_LONG_STAY, // currently we are only openeing for longStay for now
        });

      }
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_location_hero_new.scss';
</style>
